<template>
  <ion-modal
    ref="modal"
    :is-open="open"
    :initial-breakpoint="!isDesktop ? initialBreakpoint : undefined"
    :breakpoints="!isDesktop ? breakpoints : undefined"
    :presenting-element="presentingElement"
    @did-dismiss="$emit('close')"
  >
    <div class="px-16 border-b border-light modal-header">
      <div v-if="label" class="flex justify-between items-center">
        <div class="headline-lg">{{ label }}</div>
        <ion-button
          fill="clear"
          @click="$emit('close')"
        >
          Klar
        </ion-button>
      </div>
    </div>
    <ion-content>
      <slot />
    </ion-content>
  </ion-modal>
</template>

<script setup lang="ts">
import { IonModal, IonContent, IonButton } from '@ionic/vue';
import { ref } from 'vue';
import { useUiStore } from '@/store/uiStore';
import {storeToRefs} from "pinia";

const uiStore = useUiStore();

const { isDesktop } = storeToRefs(uiStore);

defineEmits<{
  (e: 'close'): void;
}>();

withDefaults(defineProps<{
  label?: string;
  open: boolean;
  breakpoints?: number[];
  initialBreakpoint?: number;
}>(), {
  breakpoints: () => [0, 0.5, 1],
  initialBreakpoint: 0.5,
});

const presentingElement = ref();

</script>

<style scoped>
.modal-header {
  padding-top: var(--ion-safe-area-top, 24px);

  @screen desk {
    padding-top: 24px;
  }
}
</style>
